import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum EnterpriseSearchSecurityRight {
    CanAccess = 32000
}

export class EnterpriseSearchSecurityModule extends BaseSecurityModule<EnterpriseSearchSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.EnterpriseSearch,
            [
                { _id: EnterpriseSearchSecurityRight.CanAccess, name: 'Access', basic: true },
            ] as SecurityRight<EnterpriseSearchSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }


}